<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'

withDefaults(
  defineProps<{
    icon?: Icons
    title: string
    subtitle?: string
    displaySubtitleOnMobile?: boolean
  }>(),
  {
    icon: null,
    subtitle: '',
    displaySubtitleOnMobile: true
  }
)
</script>
<template>
  <div class="flex items-center space-x-0 sm:space-x-6">
    <div
      v-if="icon"
      class="hidden aspect-square w-12 items-center justify-center rounded-lg bg-primary/5 text-primary sm:flex"
    >
      <BaseIcon :name="icon" class="aspect-square w-6" />
    </div>
    <div>
      <p class="text-base font-semibold text-foreground">{{ title }}</p>
      <p
        v-if="subtitle"
        class="text-sm font-normal text-muted-foreground"
        :class="{ 'hidden sm:inline-block': !displaySubtitleOnMobile }"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>
